import React from 'react';
import PropTypes from 'prop-types';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Info from '@material-ui/icons/Info';
import HelpIcon from '@material-ui/icons/Help';
import TMMenu from './TMMenu.jsx';
import { FormattedMessage } from 'react-intl';
import { NavLink, withRouter } from "react-router-dom";
import { ROUTES } from '../../pages/routes.js';
import Icon from '@mdi/react';
import { mdiGiftOutline } from '@mdi/js';
import * as Subscriptions from '../../util/subscriptions';

const moment = require('moment');

class TMProfileIconMenu extends React.Component {

	state = {
		anchorEl: null,
	};

	/* sets the anchor element to the profile menu iconbutton */
	handleMenuOpen = event => {
		window.addToDataLayer('profilemenu', 'open')
		this.setState({ anchorEl: event.currentTarget });
	};
	/* clears the anchor element, making the menu disappear */
	handleMenuClose = () => {
		window.addToDataLayer('profilemenu', 'close')
		this.setState({ anchorEl: null });
	};

	getAccountType = () => {
    const { user } = this.props;

    const now = moment();
    const isActiveSubscription = (s) => {
      return moment(s.startDate).isSameOrBefore(now, 'day') && 
      (s.endDate === null || moment(s.endDate).isSameOrAfter(now, 'day'));
    }

    if (user.subscriptions.find(s => s.subscriptionId === Subscriptions.SUBSCR_API && isActiveSubscription(s)) !== undefined) {
      return 'SCR API';
    }
    if (user.subscriptions.find(s => s.subscriptionId === Subscriptions.SUBSCR_PREMIUM_TRIAL && isActiveSubscription(s)) !== undefined) {
      return 'SCR Premium Free Trial';
    }
    if (user.subscriptions.find(s => s.subscriptionId === Subscriptions.SUBSCR_PREMIUM && isActiveSubscription(s)) !== undefined) {
      return 'SCR Premium';
    }
    if (user.subscriptions.find(s => s.subscriptionId === Subscriptions.SUBSCR_NONPAYING && isActiveSubscription(s)) !== undefined) { 
      if (user.subscriptions.find(s => s.subscriptionId === Subscriptions.SUBSCR_CLOUD_WALLET && isActiveSubscription(s)) !== undefined) { 
        return 'SCR Freemium';
      }
      if (user.subscriptions.find(s => s.subscriptionId === Subscriptions.SUBSCR_COMPANY_WALLET && isActiveSubscription(s)) !== undefined) { 
        return 'SCR Basic';
      }
    }
    return ''
  }

	render() {

		const { isAuthenticated, handleHelpClick, user, location } = this.props;
		const { anchorEl } = this.state;
		const { email, isAdmin = false, organization  } = user || {};
		const isTerminalUser = user && user.organizationRole == "terminal";
		const validTerminalUserPath = ['secure-pickup-containers'];

		return (
			<React.Fragment>
				{isAuthenticated &&
					<ClickAwayListener onClickAway={this.handleMenuClose}>
						<React.Fragment>
							<Button color="primary" onClick={this.handleMenuOpen}>
								<AccountCircle />
							</Button>
							<Button color="primary" onClick={handleHelpClick}>
								<HelpIcon />
							</Button>
							<TMMenu
								id='profile-menu'
								anchorEl={anchorEl}
								handleMenuClose={this.handleMenuClose}>
								<MenuItem disabled={true}><AccountCircle /> &nbsp; {email} </MenuItem>
								<MenuItem disabled={true}><Info /> &nbsp; {organization}</MenuItem>
								{ user.organizationRole !== 'carrier' &&
									<MenuItem disabled={true}>
										<Icon path={mdiGiftOutline} size={1} color='grey'/> &nbsp; 
										Account type: { this.getAccountType() }
									</MenuItem>
								}
								{
									ROUTES
										.filter(route =>   
											route.category === 'profile' && 
											(route.adminOnly ? isAdmin : true) &&
											(route.requiresFeature ? user.features[route.requiresFeature] : true)
											// (validTerminalUserPath.includes(route.path)? false: true)
										).filter(route => {
											return isTerminalUser ? [...validTerminalUserPath, '/'].includes(route.path): !validTerminalUserPath.includes(route.path)
										}).filter(route => {
											// Show only logout button if the path is two-factor/auth/email
											return location.pathname == '/two-factor/auth/email' ?  route.path == '/' : true
										})
										.map((route, key) => 
											<div key={key}>
												<Divider />
												<NavLink {...route.path ? { to: route.path } : {}} style={{ textDecoration: 'none' }} onClick={() => { route.onClick && route.onClick(); this.handleMenuClose(); }}>
													<MenuItem>
														<FormattedMessage id={route.title} />
													</MenuItem>
												</NavLink>
											</div>
										)
								}
							</TMMenu>
						</React.Fragment>
					</ClickAwayListener>
				}
			</React.Fragment>
		);
	}
}

TMProfileIconMenu.propTypes = {
	classes: PropTypes.object.isRequired,
	isAuthenticated: PropTypes.bool.isRequired,
};

export default withRouter(TMProfileIconMenu);

